import React, { useContext, useState } from 'react';
import { createStyles, makeStyles, withStyles, Typography,Box } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import SettingsIcon from '@material-ui/icons/Settings';
import TokenManager from 'core/auth/TokenManager';
import MoreButton from './@ui/MoreButton';
import envs from 'config/envs';
import ConfirmAction from 'stores/ConfirmAction';
import ConfirmActionPopUp from './@ui/ConfirmAction';
import { observer } from 'mobx-react-lite';
import logout from "../pictures/logout.svg"

const StyledMenuItem = withStyles((theme) => ({
  root: {
    '&::hover': {
      backgroundColor: 'transparent',
    },
  },
}))(MenuItem);

const useStyles = makeStyles((theme) =>
  createStyles({
    icon: { fill: '#2E7362' },
    logoutContainer:{
      width: "100%",
      display: 'flex',
      position: "relative",
      left: "0px",
      marginBottom:'20px',      
    },
    logoutText:{
      marginLeft:"20px"
    }
  })
);

const ProfileSettingsButton = () => {
  const manager = useContext(TokenManager);

  const handleConfirmLogOut = async () => {
    await manager.clearToken();
    
    // Check if we're on admin domain - if so, redirect to admin login, not streamer
    const isOnAdminDomain = window.location.hostname === 'admin.starfarm.com' || 
                            window.location.hostname.includes('starfarm-admin') ||
                            window.location.hostname.includes('vercel.app');
    
    if (isOnAdminDomain) {
      // Stay on admin domain for login
      window.location.href = `${window.location.origin}/login`;
    } else if (envs.streamerUri) {
      // Only redirect to streamer if not on admin domain
      window.location.href = `${envs.streamerUri}/login`;
    } else {
      // Fallback to same origin
      window.location.href = `${window.location.origin}/login`;
    }
  };

  const [confirmActionStore] = useState(new ConfirmAction());

  const handleLogOut = () => {
    confirmActionStore.setMessage('Are you sure you want to log out?');
    confirmActionStore.setTitle('Log Out');
    confirmActionStore.setConfirmOpen(true);
  };

  const classes = useStyles();

  return (
    <>
      {/* <MoreButton dropDownIcon={<SettingsIcon className={classes.icon} />}> */}
      <StyledMenuItem onClick={handleLogOut}>
        <Box className={classes.logoutContainer}>
          <img src={logout}>
          </img>
          <Typography
            variant="h4"
            className={classes.logoutText}
          >
            Log Out
          </Typography>
        </Box>
        {/* <ListItemText style={{ color: '#02172A' }} primary="Log Out" /> */}
      </StyledMenuItem>
      {/* </MoreButton> */}

      <ConfirmActionPopUp
        context={confirmActionStore}
        actionOnConfirm={handleConfirmLogOut}
      />
    </>
  );
};

export default observer(ProfileSettingsButton);
